// src/config/communityConfig.js

// Images
import dreamHero from "../images/community/dream/hero.jpg";
import dreamLogo from "../images/community/dream/logo.jpg";

import rebelHero from "../images/community/rebel/hero.jpg";
import rebelLogo from "../images/community/rebel/logo.jpg";

import buildHero from "../images/community/build/hero.jpg";
import buildLogo from "../images/community/build/logo.jpg";

import growHero from "../images/community/grow/hero.jpg";
import growLogo from "../images/community/grow/logo.jpg";

import flowHero from "../images/community/flow/hero.jpg";
import flowLogo from "../images/community/flow/logo.jpg";

export const COMMUNITY_CONFIG = {

    DREAM_KALP: {

        id: "dream",

        title: "Dream Kalp",

        shortTitle: "Dream",

        subtitle:
            "For minds that imagine new worlds before they exist.",

        description:
            "Dream Kalp is home to creators, thinkers and visionaries who believe every great reality begins as an idea. Here you'll discover conversations, stories and creations that inspire people to dream bigger.",

        heroImage: dreamHero,

        logo: dreamLogo,

        categoryMask: 2,

        shopCollection: "dream",

        accent: "#8B5CF6",

        gradient:

            "from-purple-600 via-fuchsia-500 to-pink-500",

        glow:

            "shadow-purple-500/30",

        button:

            "bg-purple-600 hover:bg-purple-700",

        badge:

            "bg-purple-100 text-purple-700",

        stats: {

            members: "24.8K",

            posts: "4.2K",

            products: "18",

            online: "1.4K"

        },

        highlights: [

            "Future Cities",

            "AI Storytelling",

            "Creative Thinking",

            "Startup Ideas"

        ]

    },

    BUILD_KALP: {

        id: "build",

        title: "Build Kalp",

        shortTitle: "Build",

        subtitle:
            "For builders who transform ideas into reality.",

        description:
            "Builders don't wait for opportunities. They create them. Explore projects, engineering discussions, startups and everything related to building meaningful things.",

        heroImage: buildHero,

        logo: buildLogo,

        categoryMask: 4,

        shopCollection: "build",

        accent: "#2563EB",

        gradient:

            "from-blue-600 via-cyan-500 to-sky-500",

        glow:

            "shadow-blue-500/30",

        button:

            "bg-blue-600 hover:bg-blue-700",

        badge:

            "bg-blue-100 text-blue-700",

        stats: {

            members: "31.2K",

            posts: "8.6K",

            products: "24",

            online: "2.1K"

        },

        highlights: [

            "Build in Public",

            "Spring Boot",

            "React",

            "Microservices"

        ]

    },

    REBEL_KALP: {

        id: "rebel",

        title: "Rebel Kalp",

        shortTitle: "Rebel",

        subtitle:
            "For people who challenge ordinary thinking.",

        description:
            "Rebel Kalp celebrates independent thinkers, fearless creators and those who choose their own path instead of following the crowd.",

        heroImage: rebelHero,

        logo: rebelLogo,

        categoryMask: 1,

        shopCollection: "rebel",

        accent: "#DC2626",

        gradient:

            "from-red-600 via-rose-500 to-orange-500",

        glow:

            "shadow-red-500/30",

        button:

            "bg-red-600 hover:bg-red-700",

        badge:

            "bg-red-100 text-red-700",

        stats: {

            members: "18.4K",

            posts: "2.8K",

            products: "15",

            online: "840"

        },

        highlights: [

            "Unpopular Opinions",

            "Leadership",

            "Freedom",

            "Innovation"

        ]

    },

    GROW_KALP: {

        id: "grow",

        title: "Grow Kalp",

        shortTitle: "Grow",

        subtitle:
            "For lifelong learners committed to becoming better every day.",

        description:
            "Growth begins with curiosity. Join discussions around books, habits, productivity and continuous self-improvement.",

        heroImage: growHero,

        logo: growLogo,

        categoryMask: 8,

        shopCollection: "grow",

        accent: "#16A34A",

        gradient:

            "from-green-600 via-emerald-500 to-lime-500",

        glow:

            "shadow-green-500/30",

        button:

            "bg-green-600 hover:bg-green-700",

        badge:

            "bg-green-100 text-green-700",

        stats: {

            members: "27.5K",

            posts: "5.4K",

            products: "22",

            online: "1.7K"

        },

        highlights: [

            "Books",

            "Habits",

            "Fitness",

            "Career Growth"

        ]

    },

    FLOW_KALP: {

        id: "flow",

        title: "Flow Kalp",

        shortTitle: "Flow",

        subtitle:
            "For people who thrive with focus, rhythm and calm execution.",

        description:
            "Flow Kalp is about mindfulness, creativity and finding your rhythm while building a meaningful life.",

        heroImage: flowHero,

        logo: flowLogo,

        categoryMask: 16,

        shopCollection: "flow",

        accent: "#EA580C",

        gradient:

            "from-orange-600 via-amber-500 to-yellow-500",

        glow:

            "shadow-orange-500/30",

        button:

            "bg-orange-600 hover:bg-orange-700",

        badge:

            "bg-orange-100 text-orange-700",

        stats: {

            members: "21.7K",

            posts: "3.6K",

            products: "17",

            online: "1.2K"

        },

        highlights: [

            "Deep Work",

            "Design",

            "Focus",

            "Creativity"

        ]

    }

};

export const getCommunity = (category) => {
    console.log("getCommunity called with category:", category);
    return COMMUNITY_CONFIG[category];
};
export const getAllCommunities = () =>
    Object.values(COMMUNITY_CONFIG);